module.exports = __webpack_public_path__ + "static/media/om_eyeshape_almond_hazel.8497ecf1.png";